import react, { useEffect, useState } from "react";
import { IDriver } from "dataModels/contract";
import { Input as TextInput, DatePicker, Select } from "@ds/ds-snam/react";
import { Row, Col } from "react-grid-system";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { dsDeselectHandler, dsSelectHandler } from "shared/utils/dsComponentUtils";
import { ISelectLabel } from "@ds/ds-snam/dist/models/select";
import { docType, docTypeEN, myCountryArraySelect, myCountryArraySelectEN, provinceMap } from "shared/domains/formDomains";
import { AppUserRole } from "shared/constants";
import useAppUser from "hooks/useAppUser";
import { AppUser } from "ooAuth2/appUser";

interface IDriverFormDataInputProps {
    formData: IDriver,
    cardCodeError: boolean,
    onTextInputChange: (inputEvent: Event) => void,
    onDateInputChange: (inputEvent: Event, fieldName: string) => void,
    onSelectInputChange: (inputEvent: Event,fieldName:string) => void
}
const DriverFormDataInput: React.FC<IDriverFormDataInputProps> = (props): JSX.Element => {
    const {t} = useTranslation(['contract', 'app']);
    const { formData, cardCodeError, onTextInputChange, onDateInputChange,onSelectInputChange } = props;
    const [provinceOptions, setProvinceOptions] = useState<ISelectLabel[]>([]);
    const [stateOptions,setStateOptions] = useState<ISelectLabel[]>([]);
    const [documentTypeOptions,setDocumentTypeOptions] = useState<ISelectLabel[]>([]);
    const appUser: AppUser | undefined = useAppUser();
    const appUserRole: AppUserRole | undefined = appUser?.getRole();
    const { i18n } = useTranslation();

    const updateStateProvince=()=>{
        if(formData.state===''){
            let states:ISelectLabel[] =i18n.language==='it'?myCountryArraySelect:myCountryArraySelectEN
            dsDeselectHandler(states)
            setStateOptions(states);
        }else{
            let selectedByLan = i18n.language==='it'?myCountryArraySelect:myCountryArraySelectEN
            setStateOptions(selectedByLan);
            const updatedProvinces = provinceMap[formData.state] || provinceMap["default"];
            setProvinceOptions(updatedProvinces);
            // Seleziona lo stato
            const selectedState = selectedByLan.find((state) => state.id === formData.state);
            if (selectedState) {
                dsSelectHandler(selectedByLan, selectedState); // Seleziona lo stato
            }

            // Seleziona la provincia
            const selectedProvince = updatedProvinces.find((province) => province.id === formData.province);
            if (selectedProvince) {
                dsSelectHandler(updatedProvinces, selectedProvince); // Seleziona la provincia
            }
        }
    }
    useEffect(()=>{
        if(formData.state===''){
            let docTypes:ISelectLabel[] =i18n.language==='it'?docType:docTypeEN
            dsDeselectHandler(docTypes)
            setDocumentTypeOptions(docTypes);
        }else{
            // Seleziona lo stato
            let selectedByLan = i18n.language==='it'?docType:docTypeEN
            setDocumentTypeOptions(selectedByLan);
            const selectedDocType = selectedByLan.find((doc) => doc.id === formData.documentType);
            if (selectedDocType) {
                dsSelectHandler(stateOptions, selectedDocType); // Seleziona lo stato
            }
        }
        updateStateProvince();
    },[])

    useEffect(()=>{
        updateStateProvince();
    },[i18n.language])
    
    return (
        <> 
            <Row>
                {/** Nome */}
                <Col xs={12} md={4}>
                    <div className="textInputWrapper">
                        <TextInput
                            inputLabel={t('drivers.driverForm.sections.dataInput.fields.0') + " *"}//"Nome"
                            inputValue={formData.firstName}
                            inputName="firstName"
                            inputId="firstName"
                            inputDescription=""
                            inputStatus="default"
                            inputPlaceholder=""
                            isDisabled={false}
                            input-event-type="single_character"
                            onInputChange={onTextInputChange}
                        />
                    </div>
                </Col>

                {/** Cognome */}
                <Col xs={12} md={4}>
                    <div className="textInputWrapper">
                        <TextInput
                            inputLabel={t('drivers.driverForm.sections.dataInput.fields.1') + " *"}//"Cognome"
                            inputValue={formData.lastName}
                            inputName="lastName"
                            inputId="lastName"
                            inputDescription=""
                            inputStatus="default"
                            inputPlaceholder=""
                            isDisabled={false}
                            input-event-type="single_character"
                            onInputChange={onTextInputChange}
                        />
                    </div>
                </Col>

            </Row>

            <Row>

                {/** Cognome */}
                <Col xs={12} md={4}>
                    <div className="textInputWrapper">
                        <TextInput
                            inputLabel={t('drivers.driverForm.sections.dataInput.fields.2') + " *"}//Luogo di nascita
                            inputValue={formData.birthPlace}
                            inputName="birthPlace"
                            inputId="birthPlace"
                            inputDescription=""
                            inputStatus="default"
                            inputPlaceholder=""
                            isDisabled={false}
                            input-event-type="single_character"
                            onInputChange={onTextInputChange}
                        />
                    </div>
                </Col>

                {/** Data nascita */}
                <Col xs={12} md={4}>
                    <div className="datePickerInputWrapper">
                        <DatePicker
                            id="birthDate"
                            datePickerTitle={t('drivers.driverForm.sections.dataInput.fields.3') + " *"}//Data di nascita
                            isRangePicker={false}
                            datePickerVariant="full-date"
                            datePickerPlaceholder=""
                            startingYear={1900}
                            endingYear={new Date().getFullYear()}
                            defaultDate={moment.unix(formData.birthDate).toDate()}
                            isDisabled={false}
                            datePickerStatus="default"
                            confirmButtonLabel="Conferma"
                            hasCloseButton={false}
                            zIndex={999}
                            isReadonly={false}
                            disabledDates={
                                {
                                    firstDisabledDate: new Date()
                                }
                            }
                            isPanelTop={true}
                            onDateSelection={(event: Event) => {
                                onDateInputChange(event, 'birthDate')
                            }}
                        ></DatePicker>
                    </div>
                </Col>

            </Row>

            <Row>

                {/** Indirizzo */}
                <Col xs={12} md={4}>
                    <div className="textInputWrapper">
                        <TextInput
                            inputLabel={t('drivers.driverForm.sections.dataInput.fields.4') + " *"}//Indirizzo
                            inputValue={formData.address}
                            inputName="address"
                            inputId="address"
                            inputDescription=""
                            inputStatus="default"
                            inputPlaceholder=""
                            isDisabled={false}
                            input-event-type="single_character"
                            onInputChange={onTextInputChange}
                        />
                    </div>
                </Col>

                <Col xs={12} md={2}>
                    <div className="textInputWrapper">
                        <TextInput
                            inputLabel={t('drivers.driverForm.sections.dataInput.fields.5') + " *"}//Civico
                            inputValue={formData.streetNumber}
                            inputName="streetNumber"
                            inputId="streetNumber"
                            inputDescription=""
                            inputStatus="default"
                            inputPlaceholder=""
                            isDisabled={false}
                            input-event-type="single_character"
                            isNumberVariant={true} //STRINGTOONLYNUMBER 
                            isReadonly={false}
                            minValue={0}
                            maxDecimalDigits={0}
                            onInputChange={onTextInputChange}
                        />
                    </div>
                </Col>

            </Row>

            <Row>
                {/** Città */}
                <Col xs={12} md={4}>
                    <div className="textInputWrapper">
                        <TextInput
                            inputLabel={t('drivers.driverForm.sections.dataInput.fields.6') + " *"}//Città
                            inputValue={formData.city}
                            inputName="city"
                            inputId="city"
                            inputDescription=""
                            inputStatus="default"
                            inputPlaceholder=""
                            isDisabled={false}
                            input-event-type="single_character"
                            onInputChange={onTextInputChange}
                        />
                    </div>
                </Col>
                
                
            </Row>
            <Row>
                {/** Cap */}
                <Col xs={12} md={2}>
                    <div className="textInputWrapper">
                        <TextInput
                            inputLabel={t('drivers.driverForm.sections.dataInput.fields.7') + " *"}//Cap
                            inputValue={formData.postalCode}
                            inputName="postalCode"
                            inputId="postalCode"
                            inputDescription=""
                            inputStatus="default"
                            inputPlaceholder=""
                            isDisabled={false}
                            isNumberVariant={true} //STRINGTOONLYNUMBER 
                            input-event-type="single_character"
                            minValue={0}
                            maxDecimalDigits={0}
                            onInputChange={onTextInputChange}
                        />
                    </div>
                </Col>
                {/** Stato */}
                <Col xs={12} md={2}>
                    <div className="textInputWrapper">
                        {i18n.language && <Select
                            id={'id-select-nation'}
                            menuPlaceholder={t('drivers.driverForm.sections.dataInput.fields.9') + " *"}//Stato
                            hasIcon={false}
                            menuOptions={stateOptions}
                            menuLabel={t('drivers.driverForm.sections.dataInput.fields.9') + " *"}//Stato
                            menuId="select-id"
                            isDisabled={false}
                            selectStatus="default"
                            onOptionSelection={(event: Event) => {
                                const selection: ISelectLabel = (event as CustomEvent).detail.option;
                                dsSelectHandler(stateOptions!, selection);
                        
                                //aggiorna province
                                const updatedProvinces = provinceMap[selection.value!] || provinceMap["default"];
                                dsDeselectHandler(updatedProvinces)
                                setProvinceOptions(updatedProvinces);
                        
                                // Pulisci il valore della provincia (stringa vuota)
                                if (JSON.stringify(updatedProvinces) !== JSON.stringify(provinceOptions)) {
                                    onSelectInputChange({ detail: { option: { value: '' } } } as unknown as CustomEvent, "province");
                                }
                                        
                                onSelectInputChange(event,"state")
                            }}
                        ></Select>}
                    </div>
                </Col>
                {/** Provincia */}
                <Col xs={12} md={2}>
                    <div className="textInputWrapper">
                        <Select
                            id="id-select-province"
                            menuPlaceholder={t('drivers.driverForm.sections.dataInput.fields.8') + " *"}//Provincia
                            menuOptions={provinceOptions} // Opzioni province dinamiche
                            menuLabel={t('drivers.driverForm.sections.dataInput.fields.8') + " *"}//Provincia
                            isDisabled={provinceOptions.length === 0} // Disabilita il menu se non ci sono province
                            onOptionSelection={(event: Event) => {
                                const selection: ISelectLabel = (event as CustomEvent).detail.option;
                                dsSelectHandler(provinceOptions!, selection);
                                onSelectInputChange(event, "province")
                            }}
                        />
                    </div>
                </Col>
            </Row>

            <Row>
                {/** Documento riconoscimento */}
                <Col xs={12} md={4}>
                    <div className="textInputWrapper">
                        {/*<TextInput
                            inputLabel={t('drivers.driverForm.sections.dataInput.fields.10') + " *"}//Documento riconoscimento
                            inputValue={formData.documentType}
                            inputName="documentType"
                            inputId="documentType"
                            inputDescription=""
                            inputStatus="default"
                            inputPlaceholder=""
                            isDisabled={false}
                            input-event-type="single_character"
                            onInputChange={onTextInputChange}
                        />*/}
                        {i18n.language && <Select
                            id="id-select-documentType"
                            menuPlaceholder={t('drivers.driverForm.sections.dataInput.fields.10') + " *"}//Documento riconoscimento
                            menuOptions={documentTypeOptions} // Opzioni docmento
                            menuLabel={t('drivers.driverForm.sections.dataInput.fields.10') + " *"}//Documento riconoscimento
                            onOptionSelection={(event: Event) => {
                                const selection: ISelectLabel = (event as CustomEvent).detail.option;
                                dsSelectHandler(documentTypeOptions, selection);
                                onSelectInputChange(event, "documentType")
                            }}
                        />}
                    </div>
                </Col>
                {/** Numero documento */}
                <Col xs={12} md={4}>
                    <div className="textInputWrapper">
                        <TextInput
                            inputLabel={t('drivers.driverForm.sections.dataInput.fields.11') +  " *"}//Numero documento
                            inputValue={formData.documentNumber}
                            inputName="documentNumber"
                            inputId="documentNumber"
                            inputDescription=""
                            inputStatus="default"
                            inputPlaceholder=""
                            isDisabled={false}
                            input-event-type="single_character"
                            onInputChange={onTextInputChange}
                        />
                    </div>
                </Col>
            </Row>
            {((formData.status.toString()==="2"||formData.status.toString()==="3"||formData.status.toString()==="4"||formData.status.toString()==="7") && (appUserRole===AppUserRole.ADMIN || appUserRole===AppUserRole.SALES_PROFILE)) && <Row>
                {/** codeCard */}
                <Col xs={12} md={4}>
                    <div className="textInputWrapper">
                        <TextInput
                            inputLabel={"Code Card"} //code card
                            inputValue={formData.cardCode}
                            inputName="cardCode"
                            inputId="cardCode"
                            inputDescription={cardCodeError ? t('drivers.driverForm.sections.dataInput.fields.12') : ""}
                            inputStatus={cardCodeError ? "error" : "default"}
                            inputPlaceholder=""
                            isDisabled={false}
                            input-event-type="single_character"
                            onInputChange={onTextInputChange}
                        />
                    </div>
                </Col>
            </Row>}
        </>)
}

export default DriverFormDataInput;